export default __webpack_public_path__ + "static/media/linkedin-black.0fd9c188.png";